module.exports = __webpack_public_path__ + "img/gmail-signature-name.40701f15.png";